module.exports = __webpack_public_path__ + "assets/img/KeyReport_Picto2.fba83407.svg";